import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Loader } from '..';
import { ReactComponent as IconArrowBack } from '../../assets/img/icn-arrow-back.svg';

import './sass/page-title.scss';

const TitleLoader = () => <div className="title-loader-wrapper"><Loader size="small" /></div>;

const PageTitle = ({ children }) => {
  React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return null;
  });

  return <div className="page-title"><div className="row">{children}</div></div>;
};

const PageTitleLeftNode = ({ children, headingText, isLoading, backUrl }) => (
  <div className="col-sm-6">
    <h3>{headingText}</h3>
    {children}
    {isLoading && <PageTitle.Loader />}
    {backUrl && (
      <div className="page-title-col1">
        <Link to={backUrl}>
          <IconArrowBack className="mr-2 svg-small" />
          Back to list view
        </Link>
      </div>
    )}
  </div>
);

const PageTitleRightNode = ({ children, text }) => {
  const textClass = text === 'left' ? '' : 'text-right';
  return (<>{children && <div className={`col-sm-6 ${textClass}`}>{children}</div>}</>);
};

PageTitle.Loader = TitleLoader;
PageTitle.Left = PageTitleLeftNode;
PageTitle.Right = PageTitleRightNode;

PageTitle.propTypes = {
  children: PropTypes.node.isRequired
};

PageTitleLeftNode.propTypes = {
  headingText: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  backUrl: PropTypes.string,
};

PageTitleRightNode.propTypes = {
  children: PropTypes.node,
  text: PropTypes.oneOf(['left', 'right']),
};

export default PageTitle;
